'use client';

import { useEffect } from 'react';

/** The owned hydration coordinator now captures before the Assistant read and
 * retains that exact receipt through target catalog and coherent publication.
 * This replaces the old record-only cross-term staging contract; old23 proof
 * remains separate and is not inherited by this assembled consumer.
 */
export function useAssistantScheduleRefresh({ refresh }: { refresh: (scheduleId: unknown) => Promise<boolean> }) {
  useEffect(() => {
    const listener = (event: Event) => {
      void refresh((event as CustomEvent<{ scheduleId?: unknown }>).detail?.scheduleId);
    };
    window.addEventListener('assistant:schedule-updated', listener);
    return () => window.removeEventListener('assistant:schedule-updated', listener);
  }, [refresh]);
}
